export default __webpack_public_path__ + "static/media/5_NakliyeBütçeOranlarÖrnekExcelData.25d613b3.xlsx";